export const typesEnum = {
    my: 'my', //если нужно отобрахить моё расписание
    all: 'all', //для ученика, если нужно отобразить своё + то что он может купить
    oneWeek: 'oneWeek', // за неделю для админа(чтобы смотреть за ученика или сотрудника)
    oneDay: 'oneDay' // за день для админа(чтобы смотреть за учеников или сотрудников)
}